import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f862709"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-faq" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "section-title" }, [
  /*#__PURE__*/_createTextVNode(" 원더플 캠페인 "),
  /*#__PURE__*/_createElementVNode("span", { class: "strong" }, "FAQ")
], -1))
const _hoisted_4 = { class: "name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1))
const _hoisted_6 = { class: "collapse-title" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "faq-content" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { key: 1 }


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const tabs = [
    {
      name: '참여 신청',
      faqs: [
        {
          title: '신청이 완료되었는지 어떻게 확인하나요?',
          content: [
            {
              text: '신청이 완료되면 등록하신 핸드폰 번호로 카카오톡 알림 메시지가 발송되며 마이페이지에서 확인 가능합니다.'
            }
          ]
        },
        {
          title: '제로웨이스트 박스는 언제 오나요?',
          content: [
            {
              text: '캠페인 참여자로 선정되신 분들께서는 선정자 발표 후 평균 3~4일 내에 제로웨이스트 박스가 배송됩니다.'
            },
            {
              text: '택배 물량 및 지역 상황에 따라 차이가 있을 수 있는 점 양해 부탁드립니다.'
            }
          ]
        },
        {
          title: '신청인 정보를 수정하고 싶습니다.',
          content: [
            {
              text: '참여 신청 페이지 – 마이 페이지에서 수정 가능합니다.'
            },
            {
              html: '<div class="text-important">※ 등록된 주소지로 제로웨이스트 박스 발송/수거 및 리워드 발송이 진행되므로 정확한 주소 입력을 부탁드립니다.</div>',
            }
          ]
        },
        {
          title: '수거 박스를 여러 개 보내주실 수 있나요?',
          content: [
            {
              text: '제로웨이스트 박스는 자원순환에 대한 인식을 많은 분들과 공유하고자 개인에게는 1인당 2개, 단체에게는 1팀당 4개(혹은 6개)만 제공됩니다. 제공되는 박스에 최대한 많은 투명 음료 페트병을 꾹!꾹! 눌러 담아 보내주시면 재활용 공정 후 소중한 자원이 될 예정입니다. '
            }
          ]
        },
        {
          title: '한 사람당 몇 번까지 참여할 수 있나요?',
          content: [
            {
              text: '한 시즌 당 1회만 참여가 가능합니다.'
            }
          ]
        },
        {
          title: '개인으로 신청한 사람이 단체로 중복 참여해도 되나요?',
          content: [
            {
              text: '개인 참여자로 이미 신청하신 경우 많은 원더플 피플이 캠페인을 경험하실 수 있도록 가급적 중복 신청을 지양해주시기 바랍니다.'
            }
          ]
        },
        {
          title: '단체로 참여 가능한가요?',
          content: [
            {
              text: '네 가능합니다. 신청 시 참여하는 단체명을 기입해 주시기 바랍니다.'
            },
            {
              text: '단, 초기 신청해 주신 대표자의 연락처/주소지로 캠페인 상황이 업데이트됩니다.'
            }
          ]
        },
        {
          title: '가족도 단체로 참여해야 할까요?',
          content: [
            {
              text: '단체의 경우 팀(직장, 학교, 동아리, 동호회 등)으로 신청해주시기를 바랍니다.  가족 구성원의 경우 개인(2박스)으로 신청 부탁드립니다. 4박스를 모두 채울 수 있다면 단체로 신청하셔도 됩니다. 약속을 꼭 지켜주세요.'
            }
          ]
        }
      ]
    },
    {
      name: '수거 신청',
      faqs: [
        {
          title: '박스 수거 신청은 어떻게 하나요? (개인 / 단체)',
          content: [
            {
              text: '해당 수거 기간 내에 박스가 채워지는 대로 사이트를 통해 수거 신청 해주시면 됩니다. 박스마다 송장이 발급되므로 박스 수량과 동일하게 수거 신청 부탁드립니다. '
            },
            {
              text: '(개인 참여자의 경우 2박스 2회 수거 신청/단체 참여자의 경우 4박스 4회 신청)'
            },
            {
              text: '제로웨이스트 박스를 수거 기간 내 올바른 방법으로 가득 채워 주셔야만 리워드 제공이 가능한 점 참고 부탁드립니다.'
            }
          ]
        },
        {
          title: '수거 신청 후 기사님께서 언제 방문하시나요?',
          content: [
            {
              text: '평일 기준 3~4일 내에 신청하신 주소로 택배 기사님께서 방문합니다.'
            }
          ]
        },
        {
          title: '수거 시 택배 비용은 본인 부담인가요?',
          content: [
            {
              text: '원더플 캠페인에 참가하신 원더플 피플의 제로웨이스트 박스는 본인 부담 없이 무료로 수거해 드립니다.'
            }
          ]
        },
        {
          title: '캠페인 기간 내에 박스를 다 채우지 못하면 어떻게 하나요?',
          content: [
            {
              text: '사전에 공지된 캠페인 기간 내에 박스를 다 채우지 못하실 경우 박스 수거 및 리워드 제공이 어려운 점 양해 부탁드립니다.'
            }
          ]
        },
        {
          title: '캠페인 기간이 지났는데 보내도 되나요?',
          content: [
            {
              text: '수거 신청은 사전에 공지된 수거 기간에만 가능하니 미리 일정을 확인해 주시기 바랍니다. 신청 기간을 놓친 참여자분들께서는 환경을 위해 모은 재활용품을 가정에서 자체적으로 꼭 분리배출 해주시기 바랍니다.'
            }
          ]
        },
        {
          title: '어떤 물품이 수거 가능한가요?',
          content: [
            {
              text: '원더플 캠페인에서는 ‘투명 음료 페트병’만 수거하고 있습니다. 보다 고품질 자원화를 위해 유색/불투명 페트병, 비음료용 페트병(식용유, 물엿 등) 또는 음료 페트컵 등은 수거 불가능하니 가정에서 분리배출 해주시기 바랍니다.'
            }
          ]
        },
        {
          title: '박스가 망가졌는데 어떻게 하나요?',
          content: [
            {
              text: '박스 파손 시, 폐기물 절감 차원에서 새로운 박스가 재발송 되지 않습니다. 본 캠페인이 환경을 위한 캠페인이다 보니 가정에서 사용 후 남은 박스를 활용하여 보내주시기 바랍니다.  많은 수거박스를 사용하게 되면 이 또한 폐기물이 또 다시 나올 수 있는 문제기에 이 부분은 양해 부탁드립니다.'
            }
          ]
        }
      ]
    },
    {
      name: '리워드',
      faqs: [
        {
          title: '리워드는 어떻게 해야 받을 수 있나요?',
          content: [
            {
              text: '아래의 분리배출 과정을 거쳐 2박스(단체의 경우 4박스 혹은 6박스)를 모두 올바른 방법으로 가득 채워 주신 분들에게 선물로 드립니다.'
            },
            {
              html: '<br>'
            },
            {
              html: '<span class="text-bold">1. 내용물을 비우고 깨끗하게 헹구기</span>'
            },
            {
              html: '<span class="text-bold">2. 라벨 깨끗하게 제거하기</span>'
            },
            {
              html: '<span class="text-bold">3. 압착 후 뚜껑 닫기</span>'
            },
            {
              html: '<span class="text-bold">4. 테라사이클로 제로웨이스트 박스 보내기</span>'
            },
            {
              html: '<br>'
            },
            {
              html: '<div class="text-important">수거 품목에 맞지 않은 내용물을 보내실 경우 개별 안내 없이 리워드 수령 대상에서 제외 될 수 있습니다.</div>',
            }
          ]
        },
        {
          title: '개인 참여자 / 단체 참여자 리워드는 무엇인가요?',
          content: [
            {
              html: '<span class="text-bold">개인의 경우</span>, 2박스 모두 올바른 방법으로 참여 및 검수 완료 시 <span class="text-bold">‘코카-콜라 보랭 캠핑의자’</span>를 선물로 드립니다.'
            },
            {
              html: '<span class="text-bold">단체의 경우</span>, 4박스 모두 올바른 방법으로 참여 및 검수 완료 시 함께 올바른 분리배출을 실천할 수 있도록 <span class="text-bold">‘코카-콜라 보랭 캠핑의자 2개 & 콕-따 2개’</span>를 선물로 드립니다. (6박스 완수 팀의 경우 코카-콜라 보랭 캠핑의자 3개 & 콕-따 4개 제공)'
            },
          ]
        },
        {
          title: '개인 참여자 / 단체 참여자는 리워드를 몇 번까지 받을 수 있나요?',
          content: [
            {
              text: '리워드는 1인(1팀) 1회만 제공 가능합니다. 다른 사람들에게도 나눠주고 싶다면, 지금 바로 <원더플 캠페인>을 소개해주세요!'
            }
          ]
        },
        {
          title: '리워드는 언제 받을 수 있나요?',
          content: [
            {
              text: '보내주신 제로웨이스트 박스를 검수 후 올바른 방법으로 참여해주신 분들에 한해 리워드를 순차적으로 배송해드릴 예정입니다. 수거-검수까지 일정 시간이 소요되어 리워드 배송까지 최대 2~3주 정도 소요될 수 있습니다. '
            },
            {
              html: '<br>'
            },
            {
              html: '<div class="text-important">※ 캠페인 운영 과정에서 일정이 변경될 수 있습니다.</div>'
            }
          ]
        },
        {
          title: '리워드는 별도로 구매할 수 있나요?',
          content: [
            {
              text: '리워드는 캠페인에 참여해주신 원더플 피플에게 감사의 의미로 제공될 예정이며, 아쉽게도 별도로 구매하실 수는 없습니다.'
            }
          ]
        }
      ]
    }
  ];


return (_ctx: any,_cache: any) => {
  const _component_AppCollapse = _resolveComponent("AppCollapse")!
  const _component_AppTab = _resolveComponent("AppTab")!
  const _component_AppTabs = _resolveComponent("AppTabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_AppTabs, { class: "faq-tabs" }, {
        trigger: _withCtx((scope) => [
          _createElementVNode("div", {
            class: _normalizeClass(["faq-tab-item", { active: scope.active }])
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(scope.label), 1)
          ], 2)
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
            return _createVNode(_component_AppTab, {
              key: tab.name,
              label: tab.name
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.faqs, (faq, index) => {
                  return (_openBlock(), _createBlock(_component_AppCollapse, {
                    key: index,
                    class: "faq-collapse"
                  }, {
                    trigger: _withCtx(({ visible }) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                      }, [
                        _hoisted_5,
                        _createElementVNode("div", _hoisted_6, _toDisplayString(faq.title), 1),
                        _createElementVNode("img", {
                          class: "indicator",
                          src: require('./images/btn-arrow-down.png')
                        }, null, 8, _hoisted_7)
                      ], 2)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faq.content, (item, contentIndex) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: contentIndex }, [
                            (item.html)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  innerHTML: item.html
                                }, null, 8, _hoisted_9))
                              : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.text), 1))
                          ], 64))
                        }), 128))
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 2
            }, 1032, ["label"])
          }), 64))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})